module.exports = __webpack_public_path__ + "static/media/documentacao_new.4c29e615.png";